import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  Inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';
import { Datastore } from '@app/core/services/datastore';
import { NotificationService } from '@app/core/services/notification.service';
import { Member } from '@app/models/member.model';
import { PasswordReset } from '@models/auth/password-reset.model';
import {
  createConfirmPasswordControl,
  createPasswordControl,
} from '@helper/validators';
import { take } from 'rxjs';

@Component({
  selector: 'app-edit-current-password-dialog',
  templateUrl: './edit-current-password-dialog.component.html',
  styleUrls: ['./edit-current-password-dialog.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,

  standalone: false,
})
export class EditCurrentPasswordDialogComponent implements OnInit {
  title: string | undefined;
  cancel: string | undefined;
  confirm: string | undefined;
  newPassword: string | undefined;
  confirmPassword: string | undefined;
  readonly passwordControl = createPasswordControl();
  readonly confirmPasswordControl = createConfirmPasswordControl(
    this.passwordControl,
  );
  passwords = {
    password: '',
    passwordConfirmation: '',
    forceUserPasswordChange: false,
    enforcePasswordChange: true,
  };
  parsedData = {
    email: '',
    expiresAt: '',
    companyId: '',
    memberId: '',
    username: '',
  };

  private member: Member;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datastore: Datastore,
    private authService: AuthService,
    private router: Router,
    private notify: NotificationService,
  ) {
    this.member = data.member;
  }

  public ngOnInit(): void {
    this.updateParsedData();
  }

  public savePassword(): void {
    this.sendResetPassword();
  }

  updateParsedData(): void {
    const cookieInfo: any = this.authService.getAuthCookieInfo();
    this.parsedData = {
      email: this.member.email,

      expiresAt: JSON.parse(cookieInfo)?.expires,

      companyId: this.member?.companySettingId,

      memberId: this.member.id,

      username: this.member?.userName,
    };
  }

  private sendResetPassword(): void {
    this.passwords.password = this.passwordControl.value;
    this.passwords.passwordConfirmation = this.confirmPasswordControl.value;
    const resetPass = this.datastore.createRecord(
      PasswordReset,
      Object.assign({}, this.passwords, this.parsedData),
    );
    resetPass
      .save()
      .pipe(take(1))
      .subscribe(
        () => {
          this.notify.showSuccess('notification.password.changed.success');
        },
        (err: HttpErrorResponse) => {
          this.notify.handleError(err);
        },
      );
  }
}
